@let userImageOrInitials = imageOrInitials();

@if (!userImageOrInitials || (!userImageOrInitials.image && !userImageOrInitials.initials)) {
  <div class="default-image" [ngClass]="{ 'impersonating-border': isImpersonating() }">
    <md-icon [icon]="defaultImageUrl"></md-icon>
  </div>
}

@if (userImageOrInitials && (userImageOrInitials?.image || userImageOrInitials?.initials)) {
  @if (userImageOrInitials?.image) {
    @if (userImageOrInitials?.image) {
      <img [src]="userImageOrInitials.image" class="user-image" [ngClass]="{ 'impersonating-border': isImpersonating() }" alt="User Avatar">
    }
  } @else {
    <div class="user-initials" [ngClass]="{ 'impersonating-border': isImpersonating() }" >{{ userImageOrInitials?.initials }}</div>
  }
}


@if (isImpersonating()) {

  <div class="impersonation-badge" md-tooltip="You are currently impersonating this user">
    <md-icon icon="untitled-ui/users/users-02"></md-icon>
  </div>
}